export const housingFilterOptions = [
    { value: 'housing', label: '주택수' },
    { value: 'rental_ratio', label: '전월세 거래비율' },
    { value: 'sale', label: '매매가' },
    { value: 'rental_price', label: '전월세가' },
];

export const populationFilterOptions = [
    // { value: 'total', label: '총인구' },
    // { value: 'male', label: '남성 인구' },
    // { value: 'female', label: '여성 인구' },
    // { value: 'density', label: '인구 밀도' },
    { value: 'population', label: '인구수' },
    { value: 'inflow', label: '전입 인구수' },
    { value: 'outflow', label: '전출 인구수' },
];
